import React from 'react';

import { List } from '@common/typescript/objects/List';

import { rest } from '@app/components/Api';
import { homeSliderVetTitle } from '@app/components/Pages/Home/homeContent';
import {
	disclaimer,
	linkItems,
	teleadviceEmbedText,
	teleadviceMastheadText,
	teleadviceRichText1,
	teleadviceRichText2,
} from '@app/components/Pages/Services/Teleadvice/TeleadviceContent';
import FaqBlock from '@app/components/UI/FaqBlock/FaqBlock';
import FaqBlockHeader from '@app/components/UI/FaqBlock/FaqBlockHeader';
import GetInTouchButton from '@app/components/UI/Forms/GetInTouch/GetInTouchButton';
import LinkBlockSmall from '@app/components/UI/LinkBlock/LinkBlockSmall';
import Masthead from '@app/components/UI/MastHead/Masthead';
import RichText from '@app/components/UI/RichText/RichText';
import SliderVet from '@app/components/UI/Slider/SliderVet';
import SloganBlockSmall from '@app/components/UI/SloganBlock/SloganBlockSmall';
import VideoEmbed from '@app/components/UI/VideoEmbed/VideoEmbed';
import teleadviceHead from '@app/images/content/teleadviceHead.jpg';
import teleadviceHeadMobile from '@app/images/content/mobile/teleadviceHead.jpg';
import { Questions } from '@app/objects/Questions';
import { Veterinarian } from '@app/objects/Veterinarian';
import HelmetProvider from '@app/providers/HelmetProvider/HelmetProvider';
import '@app/scss/components/ourServices.scss';

const Teleadvice: React.FC = () => {
	const [questions, setQuestions] = React.useState<Array<Questions>>([]);
	const [isLoading, setIsLoading] = React.useState<boolean>(true);
	const [errorMessage, setErrorMessage] = React.useState<string>('');
	const [vetList, setVetList] = React.useState<Array<Veterinarian>>([]);

	React.useEffect(() => {
		rest.get<List<Questions>>('v1/faq/teleadvicePage').then((res) => setQuestions(res.list));
		rest.get<List<Veterinarian>>('v1/veterinarians/Teleadvice')
			.then((res) => setVetList(res.list))
			.catch((err) => setErrorMessage(err))
			.finally(() => setIsLoading(false));
	}, []);

	return (
		<HelmetProvider>
			<div className="teleadvice our-services">
				<Masthead
					title="Telehospice"
					imageSrc={teleadviceHead}
					mobileSrc={teleadviceHeadMobile}
					text={teleadviceMastheadText}
					quoteAuthor="The Fiera Family"
					imageAlt="Pet euthanasia near me"
				/>
				<VideoEmbed text={teleadviceEmbedText} />
				<RichText title="What to expect from telehospice" text={teleadviceRichText1} />
				<RichText title="Telehospice sessions help answer questions like these:" text={teleadviceRichText2} />

				<SloganBlockSmall
					title="Schedule a telehospice consultation with one of our doctors"
					btnText={<>
						<a className="btn btn-primary visible-mobile" href="tel:855-933-5683">
							Call Us
						</a>
						<div className="no-visible-mobile">
							<GetInTouchButton btnClassName="btn btn-primary" />
						</div>
					</>}
					onBtnClick={() => {}}
					text={disclaimer}
					styled="slogan-block-small_white"
				/>
				{!errorMessage.length && (isLoading || vetList.length) ? (
					<SliderVet
						subtitle="Our veterinarians"
						title={homeSliderVetTitle}
						location="Viewing Telehospice Vets"
						items={vetList}
						teleadviceCapture="Telehospice"
						hideReadMore
						loading={isLoading}
					/>
				) : null}
				<div className="care-coordinator__faq">
					<div className="care-coordinator__faq-content">
						<FaqBlockHeader title="You might find yourself asking..." btnText="View all FAQ" clickUrl="/faq" />
						<FaqBlock questions={questions} />
					</div>
				</div>
				<LinkBlockSmall items={linkItems} />
			</div>
		</HelmetProvider>
	);
};

export default Teleadvice;
